import MemberList from "../components/MemberList";

const ListMemberPage = () => {
  return (
    <MemberList />
  );
};

export default ListMemberPage;
